import Vue from 'vue';
import format from 'date-fns/format';
import FileSaver from 'file-saver';

export const ClientContactListingService = {
  async getContactsList(activeInactive, sortOrder, pagination) {
    return Vue.axios
      .get('/client-contact/list', {
        params: {
          activeInactive,
          ...sortOrder,
          ...pagination
        }
      })
      .then(response => response.data);
  },
  async retrieveCount(activeInactive, searchParam) {
    return Vue.axios
      .get('/client-contact/count-records', {
        params: {
          activeInactive,
          searchParam
        }
      })
      .then(response => response.data);
  },

  async downloadExcel(activeInactive, sortOrder, paginationParameters, searchParam) {
    const response = await Vue.axios({
      url: `/client-contact/xlsx`,
      method: 'GET',
      params: {
        activeInactive,
        ...sortOrder,
        ...paginationParameters,
        searchParam
      },
      responseType: 'blob'
    });

    FileSaver.saveAs(
      response.data,
      `client-contacts-${format(new Date(), 'YYYY-MM-DD-HH-mm-ss')}.xlsx`
    );
  }
};
